export const OWNER_AUTH_LS_KEY = "maeiz-owner-auth";
export const OWNER_THEME_LS_KEY = "maeiz-owner-theme";
export const OWNER_SIDEBAR_LS_KEY = "maeiz-owner-sidebar";
export const OWNER_LANG_LS_KEY = "maeiz-owner-lang";
export const OWNER_LANGUAGE_STORE_LS_KEY = "maeiz-owner-language-store";
export const OWNER_CURRENCY_LS_KEY = "maeiz-owner-currency";

const LEGACY_OWNER_AUTH_LS_KEY = "mizora-owner-auth";
const LEGACY_OWNER_THEME_LS_KEY = "mizora-owner-theme";
const LEGACY_OWNER_SIDEBAR_LS_KEY = "mizora-owner-sidebar";

function migrateLocalStorageKey(legacyKey: string, nextKey: string): void {
    if (typeof window === "undefined") {
        return;
    }
    try {
        const nextValue = localStorage.getItem(nextKey);
        const legacyValue = localStorage.getItem(legacyKey);
        if (nextValue != null) {
            if (legacyValue != null) {
                localStorage.removeItem(legacyKey);
            }
            return;
        }
        if (legacyValue == null) {
            return;
        }
        localStorage.setItem(nextKey, legacyValue);
        localStorage.removeItem(legacyKey);
    } catch {
        return;
    }
}

export function migrateOwnerPersistKeys(): void {
    migrateLocalStorageKey(LEGACY_OWNER_AUTH_LS_KEY, OWNER_AUTH_LS_KEY);
    migrateLocalStorageKey(LEGACY_OWNER_THEME_LS_KEY, OWNER_THEME_LS_KEY);
    migrateLocalStorageKey(LEGACY_OWNER_SIDEBAR_LS_KEY, OWNER_SIDEBAR_LS_KEY);
}

migrateOwnerPersistKeys();
